import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'
import Comentarios from '../Shared/Comentarios'
import AttachedFilesBox from '../Shared/AttachedFilesBox'
import ModalAddFile from '../Shared/ModalAddFile'


import { isAllowedToViewComponent,formatcoin } from '../../utils/helpers';


import {
    updateInputs,
    enviarComentario,
    editarComentario,
    eliminarComentario,
    addHuesped,
    addFile
} from '../../actions/solicitudhoteles'



import {
    showModalSelector,
    selectFromSelector,
} from '../../actions/common'


class General extends Component {

    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_HOTELES1', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/auxiliares', fn)
    }




    getSolicitudRechazada = () => {

        let contador = 0

        if (this.props.solicitudhoteles.get('cotizaciones')) {
            contador = this.props.solicitudhoteles.get('cotizaciones').reduce((cont, cotizacion) => {
                if (cotizacion.get('aprobaciones')) {
                    const aprobaciones = cotizacion.get('aprobaciones').count()
                    const rechazados = cotizacion.get('aprobaciones').filter(aprobacion => aprobacion.get('estado') == 0).count()
                    if (aprobaciones == rechazados) {
                        cont++
                    }
                }
                return cont
            }, 0)
        }
        return contador > 0

    }

    handleOpenSelectorAddHuesped = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addHuesped(payload))
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }


	render() {

        const { id, solicitudhoteles, enums, user , comentario } = this.props

        const tipos_identificacion = enums.tipos_identificacion
        const esSuperusuario = user.get('es_superusuario')

        if (!id) return null

        const solicitudRechazada = this.getSolicitudRechazada()

        const disabled_comment = (solicitudhoteles.get('estado') === 0 || solicitudhoteles.get('estado') === 7);

        const readOnly =(solicitudhoteles.get('estado') !== 1 || !esSuperusuario);

        return (
        <Fragment>

            <BoxSection title="Información básica">

                <div className="row">

                        {
                            isAllowedToViewComponent('administrador', solicitudhoteles.get('solicitante')) && !solicitudRechazada && solicitudhoteles.get('estado') != 0 && solicitudhoteles.get('estado') != 7 ? (

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <SelectorInput value={ solicitudhoteles.getIn(['solicitante', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.solicitante`) } onReset={ () => this.props.updateInputs(`solicitud.solicitante`, null) } />
                                    </div>
                                </div>

                            ):(

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <input className="form-control input-sm" type="text" value={ solicitudhoteles.getIn(['solicitante', 'fullname']) || '' } disabled/>
                                    </div>
                                </div>


                            )
                        }

                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo</label>
                            <input className="form-control input-sm" value={ solicitudhoteles.getIn(['solicitante', 'email']) || '' } disabled />
                        </div>
                    </div>

                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">Extensión</label>
                            <input className="form-control input-sm" type="text" value={ solicitudhoteles.getIn(['solicitante', 'extension']) || '' }  disabled/>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Área</label>
                            <input className="form-control input-sm" type="text" value={ solicitudhoteles.getIn(['solicitante', 'area', 'nombre']) || '' } disabled/>
                        </div>
                    </div>

                </div>


                <div className="row">

                    {
                        isAllowedToViewComponent('administrador', solicitudhoteles.get('responsable_compras')) && !solicitudRechazada && solicitudhoteles.get('estado') != 0 && solicitudhoteles.get('estado') != 7 ? (

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Responsable de compras</label>
                                    <SelectorInput value={ solicitudhoteles.getIn(['responsable_compras', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.responsable_compras`) } onReset={ () => this.props.updateInputs(`solicitud.responsable_compras`, null) } />
                                </div>
                            </div>

                        ):(

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Responsable de compras</label>
                                    <input className="form-control input-sm" type="text" value={ solicitudhoteles.getIn(['responsable_compras', 'fullname']) || '' } disabled/>
                                </div>
                            </div>


                        )
                    }

                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo</label>
                            <input className="form-control input-sm" value={ solicitudhoteles.getIn(['responsable_compras', 'email']) || '' } disabled />
                        </div>
                    </div>

                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">Extensión</label>
                            <input className="form-control input-sm" type="text" value={ solicitudhoteles.getIn(['responsable_compras', 'extension']) || '' }  disabled/>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Fecha solicitud</label>
                            <input className="form-control input-sm" value={ moment(solicitudhoteles.getIn(['created_at'])).format('DD/MM/YYYY')  || ''  } disabled />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">No. Solicitud</label>
                            <input className="form-control input-sm" value={ solicitudhoteles.get('id') || '' } disabled />
                        </div>
                    </div>


                </div>

            </BoxSection>

            <div className="separator"></div>

            <BoxSection title="Información hospedaje">

                <div className="row">

                    <div className="col-md-10">
                        <div className="form-group">
                            <label className="control-label">Motivo del hospedaje</label>
                            <input className="form-control input-sm" type="text" value={ solicitudhoteles.get('proyecto_evento') || ''  } disabled />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Cantidad huéspedes</label>
                            <input className="form-control input-sm" type="number" min="1" max="9" value={ solicitudhoteles.getIn(['hotel', 'cant_huespedes']) || '' } disabled />
                        </div>
                    </div>

                </div>

            </BoxSection>

            <div className="separator"></div>

            <BoxSection title="Detalles de alojamiento">

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-alojamientos">
                    <thead>
                        <tr>
                            <th>Ciudad</th>
                            <th style={{ width: '15%' }}>Fecha ingreso</th>
                            <th style={{ width: '15%' }}>Fecha salida</th>
                        </tr>
                    </thead>
                    <tbody>
                        {solicitudhoteles.getIn(['hotel', 'alojamientos']).map((t,i) => {
                            return (
                                <tr key={ t.get('id') } className={ t.get('selected') ? 'info' : '' }>

                                    <td>
                                        {readOnly ? (
                                            <span>{t.get('ciudad') || ''}</span>
                                        ) : (
                                            <input className="form-control input-sm" type="text" value={ t.get('ciudad') } onChange={ e => this.props.updateInputs(`solicitud.hotel.alojamientos.${i}.ciudad`, e.target.value)}/>
                                        )}
                                    </td>
                                    <td>
                                        {readOnly ? (
                                            <span>{moment(t.get('fecha_ingreso')).format('DD/MM/YYYY')}</span>
                                        ) : (
                                            <input className="form-control input-sm" type="date" value={ t.get('fecha_ingreso') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.alojamientos.${i}.fecha_ingreso`, e.target.value)} />
                                        )}
                                    </td>
                                    <td>
                                        {readOnly ? (
                                            <span>{moment(t.get('fecha_salida')).format('DD/MM/YYYY')}</span>
                                        ) : (
                                            <input className="form-control input-sm" type="date" value={ t.get('fecha_salida') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.alojamientos.${i}.fecha_salida`, e.target.value)} />
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                {solicitudhoteles.getIn(['hotel', 'alojamientos']).map((t,i) => {
                    return (
                        <table className="table nowrap" key={`${t.get('id')}-${i}`}>
                            <tbody>
                                <tr>
                                    <td style={{width : '182px'}}>
                                        <div style={{ display: 'flex' , alignItems: 'center'}}> <label> Consumo a la habitación </label> <input type="checkbox"  className="form-control input-sm"  checked={ t.get('consumo_habitacion') } value={t.get('consumo_habitacion')} onChange={ e => this.props.updateInputs(`solicitud.hotel.alojamientos.${i}.consumo_habitacion`, e.target.checked)} disabled={readOnly}/> </div>
                                    </td>
                                    <td>
                                        {readOnly ? (
                                            <div style={{ display: 'flex' , alignItems: 'center'}}> <label> Monto de consumo </label> <input type="text"  className="form-control input-sm" style={{ marginLeft : '5px' , width: '100px'}} value={ formatcoin( t.get('monto_consumo') || '', "$") } disabled={readOnly}/> </div>
                                        ) : (
                                            <div style={{ display: 'flex' , alignItems: 'center'}}> <label> Monto de consumo </label> <input type="text"  className="form-control input-sm" style={{ marginLeft : '5px' , width: '100px'}} value={ t.get('monto_consumo') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.alojamientos.${i}.monto_consumo`, e.target.value)} disabled={!t.get('consumo_habitacion')}/> </div>
                                        )}

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )
                })}

            </BoxSection>

            <div className="separator"></div>

            <BoxSection title="Distribución de centros de costos">
                <div className="box-content" >
                    <table className="table table-condensed">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Ordenador del gasto</th>
                                <th>Centro de costo</th>
                                <th>Porcentaje</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            solicitudhoteles.getIn(['hotel', 'cencos']).count() > 0 ? (solicitudhoteles.getIn(['hotel', 'cencos']).map((x, n) => {
                                return (
                                    <tr key={ `tr[${ x.getIn(['pivot', 'id']) ? x.getIn(['pivot', 'id']) : x.getIn(['pivot', 'guid']) }]` }  className={ x.get('selected') ? 'info-dark' : '' } >
                                        <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                        <td>
                                            <input className="form-control input-sm" value={ x.getIn(['usuario', 'fullname'] || '')} disabled/>
                                        </td>
                                        <td style={{ width: '55%' }} >
                                            <input className="form-control input-sm" value={x.get('codigo') || '' } disabled/>
                                        </td>
                                        <td>
                                            <input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.getIn(['pivot', 'porcentaje']) ? x.getIn(['pivot', 'porcentaje']) : 0 } disabled />
                                        </td>
                                        <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                    </tr>
                                )
                            })) : (
                                    <tr>
                                        <td style={{ textAlign: 'center' }}>
                                            No hay distribución de centro de costos para esta solicitud
                                        </td>
                                    </tr>
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </BoxSection>

            <div className="separator"></div>

            <BoxSection title="Observaciones">
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <textarea type="text" className="form-control input-sm" rows={4} value={ solicitudhoteles.get('observaciones') || '' } disabled />
                        </div>
                    </div>
                </div>
            </BoxSection>

            <div className="separator"></div>

            <Comentarios
                foros = { solicitudhoteles.get('foros') }
                comentario = { this.props.comentario }
                updateInputs = { this.props.updateInputs }
                disabled_comment = { disabled_comment }
                enviarComentario = { this.props.enviarComentario }
                editarComentario = { this.props.editarComentario }
                eliminarComentario = { this.props.eliminarComentario }
            />

            <AttachedFilesBox
                    files={ solicitudhoteles.get('adjuntos').filter(adjunto => !adjunto.get('documento_id')) }
                    root='solicitud'
                    removeFiles = { this.props.removeFiles }
                    updateInputs = { this.props.updateInputs }
                    obj={ solicitudhoteles }
                    check={ 'solicitud' }
                    disabledAttach = {true}
            />
            <ModalAddFile
                action={() => this.props.addFile() }
            />


            <div className="separator"></div>

            <BoxSection title="Huéspedes">

            {solicitudhoteles.getIn(['hotel', 'huespedes']).map((p,i) => {

                return (

                    <Fragment key={ `Fragment[${i}]` }>

                        <div className="separator"></div>

                        <Box title={ `Huésped #${i+1}` }>

                            <Box title={ 'Información del huésped' } onModal>

                                <div className="separator"></div>

                                <div className="row">

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Tipo huésped</label>
                                            <select className="form-control input-sm" value={p.get('tipo_huesped')} onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.tipo_huesped`, e.target.value)}  disabled = {readOnly}>
                                                <option value="1">Empleado</option>
                                                <option value="2">Invitado</option>
                                            </select>
                                        </div>
                                    </div>
                                    {
                                        (p.get('tipo_huesped') == 1) ? (

                                            readOnly ? (
                                                <Fragment>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="control-label">Nombres</label>
                                                            <input className="form-control input-sm" type="text" value={ p.get('nombres') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.nombres`, e.target.value)} disabled = {readOnly}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label className="control-label">Apellidos</label>
                                                            <input className="form-control input-sm" type="text" value={ p.get('apellidos') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.apellidos`, e.target.value)} disabled = {readOnly}/>
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            ):(
                                                <Fragment>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="control-label">Nombre completo</label>
                                                            <SelectorInput value={ p.get('nombres') ? p.get('nombres') : '' } onClick={ () => this.handleOpenSelectorAddHuesped(`solicitud.hotel.huespedes.${i}`) } onReset={ () => this.props.updateInputs(`solicitud.hotel.huespedes.${i}`, { selected: p.get('selected'), guid: p.get('guid') }) } disabled = {readOnly} />

                                                        </div>
                                                    </div>
                                                </Fragment>
                                            )

                                        ) : (
                                            <Fragment>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label className="control-label">Nombres</label>
                                                        <input className="form-control input-sm" type="text" value={ p.get('nombres') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.nombres`, e.target.value)} disabled = {readOnly}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label className="control-label">Apellidos</label>
                                                        <input className="form-control input-sm" type="text" value={ p.get('apellidos') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.apellidos`, e.target.value)} disabled = {readOnly}/>
                                                    </div>
                                                </div>
                                            </Fragment>
                                        )
                                    }

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Tipo de documento</label>
                                            <select className="form-control input-sm" value={ p.get('tipo_documento') || 1 } onChange={ (e) => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.tipo_documento`, e.target.value) } disabled = {readOnly}>
                                            {
                                                Object.keys(tipos_identificacion).map((key, ikey) => {
                                                    return (
                                                        <option key={`opt[${i}][${ikey}]`} value={key}>{ tipos_identificacion[key] }</option>
                                                    )
                                                })
                                            }
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">No. de Documento</label>
                                            <input className="form-control input-sm" type="text" value={ p.get('numero_documento') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.numero_documento`, e.target.value)} disabled = {readOnly} />
                                        </div>
                                    </div>


                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Celular</label>
                                            <input className="form-control input-sm" type="text" value={ p.get('celular') || '' } onChange={ e => this.props.updateInputs(`solicitud.hotel.huespedes.${i}.celular`, e.target.value)}  disabled = {readOnly}/>
                                        </div>
                                    </div>


                                </div>

                            </Box>

                        </Box>

                    </Fragment>

                )
            })}

            </BoxSection>

            <ModalSelectorFromList />

        </Fragment>
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudhoteles.get('id'),
        solicitudhoteles: state.solicitudhoteles.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        user: state.common.get('user'),
        comentario: state.solicitudhoteles.get('comentario'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        enviarComentario: () => dispatch(enviarComentario()),
        editarComentario: (id) => dispatch(editarComentario(id)),
        eliminarComentario: (id) => dispatch(eliminarComentario(id)),
        addHuesped: (path) => dispatch(addHuesped(path)),
        addFile : () => dispatch(addFile())
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(General)



// WEBPACK FOOTER //
// ./src/components/SolicitudHoteles/General.jsx